export const setErrorCodeFun = (code: string, language: string) => {
  switch (code) {
    case 'auth.life.no.record.found':
      return language == 'en'
        ? 'Invalid login credentials, please contact our customer service hotline at 3187 6187 during our office hour or email at indlife@generali.com.hk.'
        : '登入資料無效，請於辦公時間致電客戶服務熱線 3187 6187或發送電郵至indlife@generali.com.hk。';
    case 'auth.eb.no.record.found':
      return language == 'en'
        ? 'Invalid login credentials, please contact our customer service hotline at 3187 6831 during our office hour or email at medicalcs@generali.com.hk.'
        : '登入資料無效，請於辦公時間致電客戶服務熱線 3187 6831或發送電郵至medicalcs@generali.com.hk。';
    case 'auth.life.email-mobile.contactinfo.issues':
      return language == 'en'
        ? 'We need more details to verify your inputted information, please contact our customer service hotline at 3187 6187 during our office hour or email at indlife@generali.com.hk.'
        : '我們需要額外資料以驗證您的身份，請於辦公時間致電客戶服務熱線 3187 6187或發送電郵至indlife@generali.com.hk。';
    case 'auth.eb.email-mobile.contactinfo.issues':
      return language == 'en'
        ? 'We need more details to verify your inputted information, please contact our customer service hotline at 3187 6831 during our office hour or email at medicalcs@generali.com.hk.'
        : '我們需要額外資料以驗證您的身份，請於辦公時間致電客戶服務熱線 3187 6831或發送電郵至medicalcs@generali.com.hk。';
    case 'auth.already.registered':
      return language == 'en'
        ? 'You have already registered on GenBRAVO, please log in with you existing login ID.'
        : '您已經在GenBRAVO註冊，請使用您的帳戶登入。';
    case 'auth.worst.password':
      return language == 'en' ? 'Choose a stronger password for better security.' : '選擇更强的密碼以提高安全性。';
    case 'auth.loginid.already.exists':
      return language == 'en'
        ? 'This login ID already registered, please try another.'
        : '帳戶名稱已被使用，請重新輸入。';
    case 'auth.not.allow.add.life.policy':
      return language == 'en'
        ? 'This function is not available for a dependent account.'
        : '此功能並不適用於家屬成員帳戶。';
    case 'auth.forget.password.loginid.not.found':
      return language == 'en' ? 'This is not a registered login ID.  ' : '沒有此賬戶的登記紀錄。';
    case 'auth.forget.password.email.not.match':
      return language == 'en' ? 'Invalid email address, please enter again.' : '電郵地址錯誤，請重新輸入。';
    case 'auth.forget.password.email.not.exists':
      return language == 'en' ? 'Invalid login credentials, please try again.' : '登入資料無效，請重新輸入。';
    case 'auth.forget.password.mobile.not.match':
      return language == 'en' ? 'Invalid mobile number, please try again.' : '電話號碼錯誤，請重新輸入。';
    case 'auth.forget.password.mobile.not.exists':
      return language == 'en' ? 'Invalid login credentials, please try again.' : '登入資料無效，請重新輸入。';
    case 'auth.life.forget.loginid.id.email.mobile.not.exists':
      return language == 'en' ? 'Invalid login credentials, please try again.' : '登入資料無效，請重新輸入。';
    case 'auth.life.forget.loginid.email.mobile.not.exists':
      return language == 'en' ? 'Invalid login credentials, please try again.' : '登入資料無效，請重新輸入。';
    case 'auth.life.forget.loginid.id.not.exists':
      return language == 'en' ? 'Invalid login credentials, please try again.' : '登入資料無效，請重新輸入。';
    case 'auth.eb.forget.loginid.policynumber.memberid.email.not.exists':
      return language == 'en' ? 'Invalid login credentials, please try again.' : '登入資料無效，請重新輸入。';
    case 'auth.eb.forget.loginid.email.not.exists':
      return language == 'en' ? 'The email address does not match with our record.' : '電子郵件地址與我們的記錄不符。';
    case 'auth.eb.forget.loginid.policynumber.memberid.not.exists':
      return language == 'en'
        ? 'The policy number and member id does not match with our record.'
        : '保單號碼和成員編號與我們的記錄不符。';
    case 'auth.no.active.policy.found':
      return language == 'en'
        ? 'You must have at least one life policy for sign-up.'
        : '您必須擁有至少一張人壽保單以登記帳戶。';
    case 'auth.life.account.expired':
      return language == 'en' ? 'Note: You do not have active Life Policy.' : '注意：您沒有生效中的人壽保單。';
    case 'auth.eb.life.account.expired':
      return language == 'en'
        ? 'Note: You do not have active Life Policy, please enter Group Medical policy’s registered email address or mobile number'
        : '注意：您沒有生效中的人壽保單，請輸入團體醫療保單的登記電郵地址或手機號碼';
    case 'auth.not.allow.add.eb.policy':
      return language == 'en'
        ? "This function is only applicable for connecting an employee's account."
        : '此功能只適用於連結僱員的帳戶。';
    case 'auth.password.history.exist':
      return language == 'en'
        ? 'Your password must be different from your last 10 passwords.'
        : '您的密碼必須與您過去的10個密碼不同。';
    case 'setting.password.history.exist':
      return language == 'en'
        ? 'Your password must be different from your last 10 passwords.'
        : '您的密碼必須與您過去的10個密碼不同。';
    case 'xapi.policy.mobile.has.been.used':
      return language == 'en'
        ? 'Mobile has already been used, please retry with another Mobile.'
        : '手機號碼已被使用，請使用其他手機號碼重試。';
    case 'xapi.policy.email.has.been.used':
      return language == 'en'
        ? 'Email address has already been used, please retry with another email address.'
        : '電郵地址已被使用，請使用其他電郵地址重試。';
    case 'auth.eb.account.expired':
      return language == 'en'
        ? "Note: Your Group Medical Policy is no longer effective, please enter Life policy's registered email address or mobile number."
        : '注意：您的團體醫療保單已失效，請輸入人壽保單的登記電郵地址或手機號碼。';
    case 'auth.recovery.eb.account.expired':
      return language == 'en'
        ? 'Note:  Your Group Medical Policy is no longer effective.'
        : '注意：您的團體醫療保單已失效。';
    case 'smsOtpVerification.code-not-found':
      return language == 'en'
        ? 'Incorrect verification code. Try again or reqest for a new verification code.'
        : '輸入的驗證碼不正確。請再試一次或索取新的驗證碼。';
    case 'smsOtpVerification.code-no-longer-valid':
      return language == 'en'
        ? 'Verification code has now expired, please request for a new verification code to be sent.'
        : '驗證碼已失效，請重新索取驗證碼。';
    case 'smsOtpVerification.code-expired':
      return language == 'en'
        ? 'Verification code has now expired, please request for a new verification code to be sent.'
        : '驗證碼已失效，請重新索取驗證碼。';
    case 'smsOtpVerification.retry-limit-exceeded':
      return language == 'en'
        ? 'Five incorrect attempts have been made. Please request a new code.'
        : '已輸入5次錯誤的驗證碼，請重新獲取驗證碼。';
    case 'auth.eb.email.already.exists':
      return language == 'en'
        ? 'This email has already been used, please login with this email or sign up with another email.'
        : '此電郵地址已被登記，請使用此電郵地址登入或以另一個電郵地址登記。';
    case 'auth.life.individual.not.match':
      return language == 'en'
        ? "Please tap 'Corporate' before entering the relevant information if you are a corporate client."
        : '如果您是企業客戶，請在輸入相關資料前點選「企業」。';
    case 'auth.life.corporate.not.match':
      return language == 'en'
        ? "Please tap 'Individual' before entering the relevant information if you are an individual client."
        : '如果您是個人客戶，請在輸入相關資料前點選「個人」。';
    case 'auth.login.gbuser.norecord':
      return language == 'en' ? 'Invalid login credentials, please try again.' : '登入資料無效，請重新輸入。';
    case 'auth.password.invalid.otp':
      return language == 'en'
        ? 'Invalid operation. Please re-verify the OTP and make the correct modification.'
        : '无效的操作，请重新验证OTP后进行正确修改。';
    case 'auth.password.reach.max.otp.number':
      return language == 'en'
        ? 'You’ve reached the maximum number of password reset attempts for today. Please try again tomorrow.'
        : '您今天嘗試重置密碼的次數已達上限。請明天再試。';
    case 'auth.eb.secemail.already.exists':
      return language == 'en'
        ? 'The email has already been used. Please login with this email or sign up with another email.'
        : '此電郵地址已被登記。請使用此電郵地址登入或以另一個電郵地址登記。';
    default:
      return null;
  }
};
